<div class="skeleton">
  <div class="skeleton__arrow"></div>
  <div class="skeleton__tags">
    @for (tag of tags; track index; let index = $index) {
      <div class="skeleton__tag"></div>
    }
  </div>
  <div class="skeleton__arrow"></div>
</div>
